<div class="container-carga" [ngStyle]="{'display': loader}">
  <div class="carga"></div>
</div>

<div class="sucModal">
  <div class="sucModal__header">
    <i class="mdi mdi-store-marker sucModal__icon"></i>
    <div class="sucModal__titulo">Elegí tu sucursal</div>
    <div class="sucModal__actual">Actual: <strong>{{nombreSucursal}}</strong></div>
  </div>

  <div class="sucModal__body">
    <button *ngIf="!unicaSucursal" type="button" (click)="usarMiUbicacion()" [disabled]="buscandoUbicacion" class="sucModal__btnUbicacion noselect">
      <i class="mdi" [ngClass]="buscandoUbicacion ? 'mdi-loading mdi-spin' : 'mdi-crosshairs-gps'"></i>
      {{ buscandoUbicacion ? 'Buscando sucursal más cercana...' : 'Usar mi ubicación' }}
    </button>
    <div *ngIf="errorUbicacion" class="sucModal__error">
      No pudimos acceder a tu ubicación. Por favor seleccioná tu sucursal manualmente.
    </div>

    <div class="suc-contenido" [class.suc-contenido--sin-mapa]="unicaSucursal">
      <div class="suc-lista-col">
        <div class="suc-lista">
          <div *ngFor="let suc of sucursalesPropias" class="suc-card"
            [class.activa]="sucursalSelecionada?.sucursal === suc.sucursal"
            (click)="elegirSucursal(suc.sucursal.toString())">
            <div class="suc-card-icono"><i class="mdi mdi-store-outline"></i></div>
            <div class="suc-card-info">
              <div class="suc-card-nombre">{{ suc.nombre }}</div>
              <div class="suc-card-linea" *ngIf="suc.calle || suc.barrio || suc.localidad">
                <i class="mdi mdi-map-marker-outline"></i>
                <span>{{ suc.calle }}{{ suc.numero ? ' ' + suc.numero : '' }}{{ suc.barrio ? ', ' + suc.barrio : '' }}{{ suc.localidad ? ', ' + suc.localidad : '' }}</span>
              </div>
              <div class="suc-card-linea" *ngIf="suc.telefono">
                <i class="mdi mdi-phone-outline"></i>
                <span>{{ suc.telefono }}</span>
              </div>
            </div>
            <i class="mdi mdi-check-circle suc-card-check" *ngIf="sucursalSelecionada?.sucursal === suc.sucursal"></i>
          </div>
        </div>
      </div>

      <div *ngIf="!unicaSucursal" id="mapa-sucursales" class="suc-mapa"></div>
    </div>

    <button type="button" (click)="cambiarSucursal()" [disabled]="validScuru" class="sucModal__btnConfirmar noselect">
      Confirmar sucursal
    </button>
  </div>
</div>
